/**
 * 발행기간유형(dealer.invoice_issue_term)과 발행기간의 관계.
 *
 * 코드 체계는 정본(pos_테이블스펙명세서 dealer.invoice_issue_term, C410 프로토타입 ISSUE_TERM_NM)
 * 기준이다 — 0.미발행 1.말일 2.15일 3.20일 4.25일 5.말일하루전 6.수시.
 * 기간의 "길이"가 아니라 **마감(발행) 기준일**을 뜻한다.
 *
 * 0(미발행)은 검색조건으로 쓰지 않는다. 대상 거래처 조회가 0을 제외하므로 고르면 결과가 늘 비어 있다.
 */

/** 수시 발행. 거래처 1건만 대상이고 확장코드·유종 필터를 쓸 수 있다 */
export const ISSUE_TERM_AD_HOC = '6';

export const ISSUE_TERM_LABEL: Record<string, string> = {
  '1': '1. 말일',
  '2': '2. 15일',
  '3': '3. 20일',
  '4': '4. 25일',
  '5': '5. 말일 하루 전',
  '6': '6. 수시',
};

/** 이번 달 1일~말일. toISOString 은 UTC 라 KST 매월 1일 09시 이전에 전월이 나오므로 로컬 시각으로 만든다 */
export function currentMonthRange(): { start: string; end: string } {
  const now = new Date();
  const y = now.getFullYear();
  const m = String(now.getMonth() + 1).padStart(2, '0');
  const last = new Date(y, now.getMonth() + 1, 0).getDate();
  return { start: `${y}-${m}-01`, end: `${y}-${m}-${String(last).padStart(2, '0')}` };
}

/**
 * 발행기간 보정(PRD §2.7.2, 정본 onDateRangeChange). C410·C420 공용.
 *
 * ① 시작월≠종료월이면 종료일자를 시작월에 맞춘다 — 종료일자를 바꾼 경우 시작월 말일로, 시작일자를 바꾼 경우
 *    시작일자와 같게. ② 같은 월인데 종료<시작이면 종료=시작. 보정이 일어나면 안내 문구를 함께 돌려준다.
 */
export function clampDateRange(
  start: string,
  end: string,
  changed: 'start' | 'end'
): { start: string; end: string; message?: string } {
  if (!start || !end) return { start, end };
  const startMonth = start.slice(0, 7);
  if (startMonth !== end.slice(0, 7)) {
    const [y, m] = startMonth.split('-').map(Number);
    const lastDay = String(new Date(y, m, 0).getDate()).padStart(2, '0');
    return {
      start,
      end: changed === 'end' ? `${startMonth}-${lastDay}` : start,
      message: '발행기간의 시작월과 종료월은 같아야 합니다. 종료일자를 시작월 기준으로 조정했습니다.',
    };
  }
  if (end < start) {
    return {
      start,
      end: start,
      message: '발행기간의 종료일자는 시작일자보다 빠를 수 없습니다. 종료일자를 시작일자와 동일하게 조정했습니다.',
    };
  }
  return { start, end };
}
